import { FormBlockType, FormFieldInputType } from "../FormTypes";

// probably unnecessary but whatever
// a wrapper function to ensure preload is only called once for each type
const cacheWrapper = <T extends string>(fn: (arg: T) => void) => {
  const cache = new Set<T>();
  return (arg: T) => {
    if (!cache.has(arg)) {
      cache.add(arg);
      fn(arg);
    }
  };
};

// This is very verbose and kinda ugly but it has to be
// creating any sort of dynamic path for the import breaks the preact code splitting logic
const _preload = cacheWrapper(
  async (type: FormFieldInputType | FormBlockType) => {
    let module: any; // any here because preact will change the type of imports at build time so the types you're dealing with at dev time and build time are different and then TS is unhappy
    switch (type) {
      case "checkbox": {
        module = await import("../components/async/Legal");
        break;
      }
      case "dob": {
        module = await import("../components/async/DateOfBirth");
        break;
      }
      case "date": {
        module = await import("../components/async/DatePicker");
        break;
      }
      case "multi-select": {
        module = await import("../components/async/MultiSelect");
        break;
      }
      case "radio": {
        module = await import("../components/async/RadioInput");
        break;
      }
      case "nps":
      case "agree_disagree": {
        module = await import("../components/async/Range");
        break;
      }
      case "select": {
        module = await import("../components/async/Select");
        break;
      }
      case "textarea": {
        module = await import("../components/async/TextArea");
        break;
      }
      case "text":
      case "email": {
        module = await import("../components/async/TextInput");
        break;
      }
      case "phone": {
        module = await import("../components/async/PhoneNumber");
        break;
      }
      case "image": {
        module = await import("../components/async/Image");
        break;
      }
      case "ranking": {
        module = await import("../components/async/Ranking");
        break;
      }
      case "star_rating": {
        module = await import("../components/async/StarRating");
        break;
      }
      case "text_content": {
        module = await import("../components/async/TextContent");
        break;
      }
      case "file": {
        module = await import("../components/async/FileUpload");
        break;
      }
      default: {
        console.error(`Couldn't preload type: ${type}`);
      }
    }

    if (module?.default?.preload) {
      module.default.preload();
    }
  }
);

const preload = (requiredTypes: (FormFieldInputType | FormBlockType)[]) =>
  requiredTypes.forEach(_preload);

export default preload;
